import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Typography,
    Container,
    Grid,
    Card,
    CardHeader,
    Avatar,
    IconButton,
    CardMedia,
    CardContent,
    CardActions,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';

import clsx from 'clsx';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ImageIcon from '@material-ui/icons/Image';
import WorkIcon from '@material-ui/icons/Work';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import * as Icons from '@material-ui/icons';
import axios from 'axios';
import ThermometerIcon from './icons/warm.svg';
import Loading from '../../../Loading/Loading';

import './Stations.css';

const useStylesList = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        backgroundColor: "#3598dc !important" //blue of metronic
    },
    avatarEMA: {
        backgroundColor: "#26a69a" //este es green de metronic. (#44b6ae) green-haze of metronic
    }
}));

const useStylesCard = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
        width: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
}));

const useStyles = makeStyles((theme) => ({
    root: {
        height: 180,
    },
    rootGrd: {
        flexFlow: 1,
    },
    wrapper: {
        width: 100 + theme.spacing(2),
    },
    paper: {
        zIndex: 1,
        position: 'relative',
        margin: theme.spacing(1),
        padding: theme.spacing(5)
    },
    paperGrd: {
        height: 500,
        width: 300,
    },
    svg: {
        width: 100,
        height: 100,
    },
    polygon: {
        fill: theme.palette.common.white,
        stroke: theme.palette.divider,
        strokeWidth: 1,
    },
    typography: {
        color: "#2a0e72",
        margin: "40px 0px"
    },
}));

export default function Stations(props) {
    const classes = useStyles();
    const classesCard = useStylesCard();
    const classesList = useStylesList();


    const [elevation, setElevation] = useState(1);
    // elevations for emcs card
    const [elevation363, setElevation363] = useState(1);
    const [elevation364, setElevation364] = useState(1);
    const [elevation366, setElevation366] = useState(1);
    // elevations for emas card
    const [elevation4, setElevation4] = useState(1);
    const [elevation5, setElevation5] = useState(1);
    const [elevation6, setElevation6] = useState(1);

    const [expanded, setExpanded] = useState(false);

    // emas actual data
    const [emas, setEmas] = useState([]);

    const [isLoadingEmas, setIsLoadingEmas] = useState(true);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        window.scrollTo(0, 1);

        const url = 'https://estaciones.scu.insmet.cu/api/actual/ema';
        async function fetchEmasActual() {
            const response = await fetch(url);
            const data = await response.json();

            setEmas(data.data);

            setIsLoadingEmas(false);
        }

        fetchEmasActual();
    }, []);

    const currentDate = new Date();

    function setElevationAux(newElevation, stationId) {
        switch (stationId) {
            case 78363:
                setElevation363(newElevation);
                break;
            case 78364:
                setElevation364(newElevation);
                break;
            case 78366:
                setElevation366(newElevation);
                break;
            case 4:
                setElevation4(newElevation);
                break;
            case 5:
                setElevation5(newElevation);
                break;
            case 6:
                setElevation6(newElevation);
                break;

            default:
                break;
        }
    }

    const emcs = [
        { id: 78363, name: 'Contramaestre', elevation: elevation363, index: 0, data: { nombre: '', magnitudes: [] } },
        { id: 78364, name: 'Universidad', elevation: elevation364, index: 1, data: { nombre: '', magnitudes: [] } },
        { id: 78366, name: 'Gran Piedra', elevation: elevation366, index: 2, data: { nombre: '', magnitudes: [] } }
    ];

    // const emas = [
    //     { id: 4, name: 'Ema Contramaestre', elevation: elevation4, index: 0, data: { nombre: '', magnitudes: [] } },
    //     { id: 5, name: 'Ema Universidad', elevation: elevation5, index: 1, data: { nombre: '', magnitudes: [] } },
    //     { id: 6, name: 'Ema Gran Piedra', elevation: elevation6, index: 2, data: gpSatationData }
    // ];

    return (
        <section id="stations">
            <div className="features-bg">
                <Container>
                    <div className="heading">
                        <h4 className="efecto-espejo">Estaciones Meteorológicas</h4>
                    </div>

                    {<Typography variant="h6" className={classes.typography} align="center">Automáticas</Typography>}
                    {isLoadingEmas && <Loading />}
                    <Grid container className={classes.rootGrd} justify="center" spacing={3}>
                        {
                            emas.map((ema, index) => {

                                let emaFecha = '';
                                let emaHora = '';
                                if (ema.timeStamp) {
                                    const timeStamp = ema.timeStamp.split(' ');
                                    emaFecha = timeStamp[0].split('-').reverse().join('/');
                                    emaHora = timeStamp[1].split(':')[0] + ':' + timeStamp[1].split(':')[1];
                                }

                                return (
                                    <Grid key={index} item>
                                        <Card className={classesCard.root} elevation={elevation4} onMouseOver={() => setElevationAux((ema.index === index) ? 10 : 1, ema.id)} onMouseOut={() => setElevationAux(1, ema.id)}>
                                            <CardHeader
                                                avatar={
                                                    <Avatar aria-label="recipe" className={classesCard.avatar}>
                                                        EA
                                                    </Avatar>
                                                }
                                                action={
                                                    <IconButton aria-label="settings">
                                                        <MoreVertIcon onClick={() => console.log('hola icon')} />
                                                    </IconButton>
                                                }
                                                title={ema.lugar}
                                                subheader={emaFecha + ' ' + emaHora + ' Hrs'}
                                            />
                                            <CardMedia
                                                className={classesCard.media}
                                                image={"assets/frontend/pages/img/photos/img" + (ema.nombre) + ".jpg"}
                                                title={"Station " + (ema.nombre)}
                                            />
                                            <CardContent>
                                                <List className={classesList.root}>
                                                    {
                                                        ema.magnitudes && ema.magnitudes.map((magnitude, magnitudeIndex) => {
                                                            let currentIcon;
                                                            switch (magnitude.short) {
                                                                case 'ff':
                                                                    currentIcon = <Icons.NearMe />;

                                                                    break;
                                                                case 'dd':
                                                                    currentIcon = <Icons.Games />;

                                                                    break;
                                                                case 'T':
                                                                    currentIcon = <embed src={ThermometerIcon} alt="Temperatura" />;

                                                                    break;
                                                                case 'HR':
                                                                    currentIcon = <Icons.Cloud />;

                                                                    break;
                                                                case 'P':
                                                                    currentIcon = <Icons.Speed />;

                                                                    break;
                                                                case 'S':
                                                                    currentIcon = <Icons.WbSunny />;

                                                                    break;
                                                                case 'R24':
                                                                    currentIcon = <Icons.BeachAccess />;

                                                                    break;

                                                                default:
                                                                    break;
                                                            }

                                                            return (
                                                                <ListItem key={magnitudeIndex}>
                                                                    <ListItemAvatar>
                                                                        <Avatar className={classesList.avatarEMA}>
                                                                            {currentIcon}
                                                                        </Avatar>
                                                                    </ListItemAvatar>
                                                                    <ListItemText primary={magnitude.name} secondary={`${isNaN(magnitude.meanValue.value) ? magnitude.meanValue.value : parseFloat(magnitude.meanValue.value)} ${magnitude.unit ?? ''}`} />
                                                                </ListItem>
                                                            )
                                                        })
                                                    }
                                                    {/* <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatarEMA}>
                                                        <embed src={ThermometerIcon} alt="Temperatura" className="123" />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Humedad Relativa" secondary="65 %" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatarEMA}>
                                                        <Icons.BeachAccess />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Precipitación" secondary="14 mm" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatarEMA}>
                                                        <Icons.Speed />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Presión Atmosférica" secondary="10013 hPa" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatarEMA}>
                                                        <Icons.NearMe />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Velocidad del Viento" secondary="12 m/s" />
                                            </ListItem> */}
                                                </List>
                                            </CardContent>
                                            {/* <CardActions disableSpacing>
                                        <IconButton aria-label="add to favorites">
                                            <FavoriteIcon />
                                        </IconButton>
                                        <IconButton aria-label="share">
                                            <ShareIcon />
                                        </IconButton>
                                        <IconButton
                                            className={clsx(classesCard.expand, {
                                                [classesCard.expandOpen]: expanded,
                                            })}
                                            onClick={handleExpandClick}
                                            aria-expanded={expanded}
                                            aria-label="show more"
                                        >
                                            <ExpandMoreIcon />
                                        </IconButton>
                                    </CardActions> */}
                                            {/* <Collapse in={expanded} timeout="auto" unmountOnExit>
                                        <CardContent>
                                            <Typography paragraph>Method:</Typography>
                                            <Typography paragraph>
                                                Heat 1/2 cup of the broth in a pot until simmering, add saffron and set aside for 10
                                                minutes.
                                            </Typography>
                                            <Typography paragraph>
                                                Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
                                                heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
                                                browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
                                                and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
                                                pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
                                                saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
                                            </Typography>
                                            <Typography paragraph>
                                                Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook
                                                without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to
                                                medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook
                                                again without stirring, until mussels have opened and rice is just tender, 5 to 7
                                                minutes more. (Discard any mussels that don’t open.)
                                            </Typography>
                                            <Typography>
                                                Set aside off of the heat to let rest for 10 minutes, and then serve.
                                            </Typography>
                                        </CardContent>
                                    </Collapse> */}
                                        </Card>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>

                    {/* <Paper elevation={elevation} className={classes.paper} onMouseOver={() => setElevation(10)} onMouseOut={() => setElevation(0)}> */}
                    <Typography variant="h6" className={classes.typography} align="center">Convencionales</Typography>
                    <Grid container className={classes.rootGrd} justify="center" spacing={3}>
                        {emcs.map((station, index) => (
                            <Grid key={station.id} item>
                                <Card className={classesCard.root} elevation={station.elevation} onMouseOver={() => setElevationAux((station.index === index) ? 10 : 1, station.id)} onMouseOut={() => setElevationAux(1, station.id)}>
                                    <CardHeader
                                        avatar={
                                            <Avatar aria-label="recipe" className={classesCard.avatar}>
                                                EC
                                            </Avatar>
                                        }
                                        action={
                                            <IconButton aria-label="settings">
                                                <MoreVertIcon onClick={() => console.log('hola icon')} />
                                            </IconButton>
                                        }
                                        title={station.name}
                                        subheader={currentDate.getDate() + '/' + currentDate.getMonth() + '/' + currentDate.getFullYear()}
                                    />
                                    <CardMedia
                                        className={classesCard.media}
                                        image={"assets/frontend/pages/img/photos/img" + (station.id - 78362) + ".jpg"}
                                        title={"Estación " + station.id}
                                    />
                                    <CardContent>
                                        <List className={classesList.root}>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatar}>
                                                        <Icons.Cloud />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Humedad Relativa" secondary="65 %" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatar}>
                                                        <Icons.BeachAccess />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Precipitación" secondary="14 mm" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatar}>
                                                        <Icons.Speed />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Presión Atmosférica" secondary="10013 hPa" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar className={classesList.avatar}>
                                                        <Icons.NearMe />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary="Velocidad del Viento" secondary="12 m/s" />
                                            </ListItem>
                                        </List>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/* <IconButton aria-label="add to favorites">
                                            <FavoriteIcon />
                                        </IconButton>
                                        <IconButton aria-label="share">
                                            <ShareIcon />
                                        </IconButton>
                                        <IconButton
                                            className={clsx(classesCard.expand, {
                                                [classesCard.expandOpen]: expanded,
                                            })}
                                            onClick={handleExpandClick}
                                            aria-expanded={expanded}
                                            aria-label="show more"
                                        >
                                            <ExpandMoreIcon />
                                        </IconButton> */}
                                    </CardActions>
                                    {/* <Collapse in={expanded} timeout="auto" unmountOnExit>
                                        <CardContent>
                                            <Typography paragraph>Method:</Typography>
                                            <Typography paragraph>
                                                Heat 1/2 cup of the broth in a pot until simmering, add saffron and set aside for 10
                                                minutes.
                                            </Typography>
                                            <Typography paragraph>
                                                Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
                                                heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
                                                browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
                                                and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
                                                pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
                                                saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
                                            </Typography>
                                            <Typography paragraph>
                                                Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook
                                                without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to
                                                medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook
                                                again without stirring, until mussels have opened and rice is just tender, 5 to 7
                                                minutes more. (Discard any mussels that don’t open.)
                                            </Typography>
                                            <Typography>
                                                Set aside off of the heat to let rest for 10 minutes, and then serve.
                                            </Typography>
                                        </CardContent>
                                    </Collapse> */}
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                    {/* </Paper> */}

                </Container>
            </div>
        </section>
    );
}